<script setup>
import EventActionsCell from "@frontJs/components/tables/cells/projectManagement/sem/tenantReports/EventActionsCell.vue";
import { PlusIcon } from "@heroicons/vue/24/solid";
import ActionButton from "@js/components/ActionButton.vue";
import LoadingSpinner from "@js/components/LoadingSpinner.vue";
import DataTableLayout from "@js/components/tables/DataTableLayout.vue";
import LinkCellV2 from "@js/components/tables/cells/LinkCellV2.vue";
import NumberCell from "@js/components/tables/cells/NumberCell.vue";
import { useDataTable } from "@js/utils/dataTable";
import { useRoute } from "@js/utils/route";
import { createColumnHelper } from "@tanstack/vue-table";
import { h } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { userSessionKey } = defineProps({
  userSessionKey: {
    type: String,
    required: false,
  },
});

const { route } = useRoute();

const columnHelper = createColumnHelper();

const {
  loading,
  table,
  count,
  globalFilter,
  filters,
  availableFilters,
  setGlobalFilter,
  setFilters,
} = useDataTable({
  columns: [
    columnHelper.accessor(() => null, {
      id: "name",
      header: () => t("label.name"),
      cell: (props) =>
        h(LinkCellV2, {
          text: props.row.original.name,
          href: route("front.projectManagement.sem.events", {
            tenant: props.row.original.id,
          }),
          inertia: true,
        }),
    }),
    columnHelper.accessor(() => null, {
      id: "createdByApikom",
      header: () => t("label.createdByApikom"),
      cell: (props) =>
        h(NumberCell, {
          number: props.row.original.createdByApikom,
        }),
    }),
    columnHelper.accessor(() => null, {
      id: "createdByCustomer",
      header: () => t("label.createdByCustomer"),
      cell: (props) =>
        h(NumberCell, {
          number: props.row.original.createdByCustomer,
        }),
    }),
    columnHelper.display({
      id: "actions",
      header: t("label.actions"),
      cell: (innerProps) =>
        h(EventActionsCell, {
          row: innerProps.row,
        }),
    }),
  ],
  url: route("front.projectManagement.sem.postEvents"),
  userSessionKey: userSessionKey,
  columnPinning: {
    right: ["actions"],
  },
});
</script>

<template>
  <LoadingSpinner v-if="loading" />

  <div v-else>
    <DataTableLayout
      :table="table"
      :count="count"
      :global-filter="globalFilter"
      :filters="filters"
      :available-filters="availableFilters"
      :set-filters="setFilters"
      :set-global-filter="setGlobalFilter"
    >
      <template #actions>
        <ActionButton
          size="small"
          :href="route('front.projectManagement.sem.createEvent')"
          :left-icon="PlusIcon"
        >
          {{ t("button.add") }}
        </ActionButton>
      </template>
    </DataTableLayout>
  </div>
</template>
